import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import usePageTitle from "@/hooks/usePageTitle";

export default function TermsPage() {
  usePageTitle("pageTitles.terms");
  return (
    <div
      className="min-h-screen bg-slate-950 text-slate-100"
      data-testid="terms-page"
    >
      <div className="max-w-3xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors mb-8"
          data-testid="terms-page-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-slate-950">
            <FileText className="h-5 w-5" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">
            Terms &amp; Conditions
          </h1>
        </div>

        <p className="text-xs uppercase tracking-wider text-amber-400 mb-8">
          Effective Date: September 30, 2026
        </p>

        <div className="prose prose-invert prose-slate max-w-none space-y-6 text-slate-300 leading-relaxed">
          <p>
            Welcome to <strong className="text-white">PlateProfit</strong>, a
            Software-as-a-Service (SaaS) platform owned and operated by
            Kritajna Ventures LLP. By accessing or using{" "}
            <span className="text-amber-400">plateprofit.app</span>, you agree
            to be bound by these Terms and Conditions.
          </p>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Description of Service
            </h2>
            <p>
              PlateProfit provides cloud-based restaurant management tools on a
              subscription basis.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">User Accounts</h2>
            <p>
              You agree to provide accurate information during registration and
              are responsible for safeguarding your account.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Subscription Fees and Payment
            </h2>
            <p>
              By selecting a subscription plan, you authorize us and our payment
              processors (e.g., xPay, Razorpay) to charge your payment method
              on a recurring basis. Price changes will be communicated in
              advance.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Intellectual Property
            </h2>
            <p>
              The PlateProfit platform is the exclusive property of Kritajna
              Ventures LLP. Your uploaded data remains your exclusive property.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Limitation of Liability
            </h2>
            <p>
              Kritajna Ventures LLP shall not be liable for indirect or
              consequential damages arising out of your use of the service.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the
              laws of the Republic of India.
            </p>
          </section>

          <p className="text-xs text-slate-500 pt-6 border-t border-slate-800">
            Questions? Contact{" "}
            <a
              href="mailto:admin@kritajnaventures.com"
              className="text-amber-400 hover:underline"
            >
              admin@kritajnaventures.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
